/* Beuvana theme scripts — vanilla JS, no dependencies. */
(function () {
  'use strict';

  var routes = (window.beuvana && window.beuvana.routes) || {};
  var strings = (window.beuvana && window.beuvana.strings) || {};

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function formatMoney(cents) {
    var format = (window.beuvana && window.beuvana.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withComma = parts.join('.');
    var noDecimals = parts[0];

    return format
      .replace(/\{\{\s*amount\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals);
  }

  /* ----------------------------------------------------------------------
     Drawers (mobile menu, cart drawer)
     ---------------------------------------------------------------------- */

  var lastFocused = null;

  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var focusTarget = drawer.querySelector('[data-drawer-close], a, button');
    if (focusTarget) focusTarget.focus();
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')));
      return;
    }

    var closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.closest('.drawer'));
      return;
    }

    if (event.target.classList && event.target.classList.contains('drawer__overlay')) {
      closeDrawer(event.target.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openedDrawer = $('.drawer.is-open');
    if (openedDrawer) closeDrawer(openedDrawer);
    var openedSearch = $('.search-modal.is-open');
    if (openedSearch) closeSearch(openedSearch);
  });

  /* ----------------------------------------------------------------------
     Search modal
     ---------------------------------------------------------------------- */

  function closeSearch(modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-search-open]');
    if (toggle) {
      event.preventDefault();
      var modal = $('.search-modal');
      if (!modal) return;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      var input = $('input[type="search"]', modal);
      if (input) window.setTimeout(function () { input.focus(); }, 60);
      return;
    }

    var close = event.target.closest('[data-search-close]');
    if (close) {
      event.preventDefault();
      closeSearch(close.closest('.search-modal'));
      return;
    }

    var modalEl = $('.search-modal.is-open');
    if (modalEl && event.target === modalEl) closeSearch(modalEl);
  });

  /* ----------------------------------------------------------------------
     Announcement bar rotation
     ---------------------------------------------------------------------- */

  $$('[data-announcement]').forEach(function (bar) {
    var slides = $$('.announcement__slide', bar);
    if (slides.length < 2) return;
    var interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
    var index = 0;
    window.setInterval(function () {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    }, interval);
  });

  /* ----------------------------------------------------------------------
     Quantity steppers
     ---------------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty-change]');
    if (!button) return;
    event.preventDefault();

    var wrapper = button.closest('.qty');
    var input = $('input', wrapper);
    if (!input) return;

    var step = button.getAttribute('data-qty-change') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;
    var next = (parseInt(input.value, 10) || min) + step;
    if (next < min) next = min;

    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ----------------------------------------------------------------------
     Product gallery thumbnails
     ---------------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-thumb]');
    if (!thumb) return;
    event.preventDefault();

    var gallery = thumb.closest('[data-gallery]');
    var main = $('[data-gallery-main] img', gallery);
    var image = $('img', thumb);
    if (!main || !image) return;

    main.src = image.getAttribute('data-full') || image.src;
    main.srcset = '';
    main.alt = image.alt;

    $$('[data-thumb]', gallery).forEach(function (item) {
      item.classList.toggle('is-active', item === thumb);
    });
  });

  /* ----------------------------------------------------------------------
     Variant picker
     ---------------------------------------------------------------------- */

  function initVariantPicker(scope) {
    var dataEl = $('[data-variant-json]', scope);
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    var idInput = $('[data-variant-id]', scope);
    var priceEl = $('[data-price-target]', scope);
    var submit = $('[data-add-to-cart]', scope);
    var stockEl = $('[data-stock-target]', scope);

    function currentOptions() {
      return $$('[data-option-index]', scope)
        .filter(function (input) {
          return input.type === 'radio' ? input.checked : true;
        })
        .sort(function (a, b) {
          return a.getAttribute('data-option-index') - b.getAttribute('data-option-index');
        })
        .map(function (input) { return input.value; });
    }

    function matchVariant(selected) {
      return variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === selected[index];
        });
      });
    }

    function update() {
      var selected = currentOptions();
      var variant = matchVariant(selected);

      $$('[data-option-value-label]', scope).forEach(function (label) {
        var groupIndex = label.getAttribute('data-option-value-label');
        var group = $('[data-option-group="' + groupIndex + '"]', scope);
        if (!group) return;
        var checked = $('input:checked', group);
        label.textContent = checked ? checked.value : '';
      });

      if (!variant) {
        if (idInput) idInput.value = '';
        if (submit) {
          submit.disabled = true;
          submit.textContent = strings.unavailable || 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (window.history.replaceState && scope.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      if (priceEl) {
        var html = '<span class="price__' + (variant.compare_at_price > variant.price ? 'sale' : 'regular') + '">' +
          formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price > variant.price) {
          html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = html;
      }

      if (stockEl) {
        if (!variant.available) {
          stockEl.innerHTML = '<span class="stock-dot stock-dot--out"></span>' + (strings.soldOut || 'Sold out');
        } else if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
          stockEl.innerHTML = '<span class="stock-dot stock-dot--low"></span>' +
            (strings.inventoryLow || 'Only __COUNT__ left').replace('__COUNT__', variant.inventory_quantity);
        } else {
          stockEl.innerHTML = '<span class="stock-dot"></span>' + (strings.inStock || 'In stock, ready to ship');
        }
      }

      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available
          ? (strings.addToCart || 'Add to bag')
          : (strings.soldOut || 'Sold out');
      }
    }

    scope.addEventListener('change', function (event) {
      if (event.target.hasAttribute('data-option-index')) update();
    });

    update();
  }

  $$('[data-variant-context]').forEach(initVariantPicker);

  /* ----------------------------------------------------------------------
     Add to cart (AJAX) + cart count
     ---------------------------------------------------------------------- */

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshCartCount() {
    fetch(routes.cart_url + '.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () { /* no-op */ });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-ajax-cart]');
    if (!form) return;

    event.preventDefault();

    var button = $('[type="submit"]', form);
    var originalText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = '…';
    }

    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: new FormData(form)
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);
        refreshCartCount();
        if (button) {
          button.textContent = strings.added || 'Added';
          window.setTimeout(function () {
            button.textContent = originalText;
            button.disabled = false;
          }, 1600);
        }
        document.dispatchEvent(new CustomEvent('beuvana:cart:added', { detail: data }));
      })
      .catch(function (error) {
        if (button) {
          button.textContent = originalText;
          button.disabled = false;
        }
        window.alert(error.message || 'Sorry, that item could not be added.');
      });
  });

  /* ----------------------------------------------------------------------
     Cart page line item updates
     ---------------------------------------------------------------------- */

  function changeCartLine(line, quantity) {
    fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (response) { return response.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-quantity]');
    if (!input) return;
    changeCartLine(input.getAttribute('data-line'), parseInt(input.value, 10) || 0);
  });

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    changeCartLine(remove.getAttribute('data-line'), 0);
  });

  /* ----------------------------------------------------------------------
     Collection sort
     ---------------------------------------------------------------------- */

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-sort-by]');
    if (!select) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ----------------------------------------------------------------------
     Facet filters — submit the form on any change
     ---------------------------------------------------------------------- */

  document.addEventListener('change', function (event) {
    var form = event.target.closest('[data-facet-form]');
    if (!form) return;
    form.submit();
  });

  /* ----------------------------------------------------------------------
     Scroll reveal
     ---------------------------------------------------------------------- */

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.08 });

    $$('.reveal').forEach(function (el) { observer.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ----------------------------------------------------------------------
     Theme editor support
     ---------------------------------------------------------------------- */

  document.addEventListener('shopify:section:load', function (event) {
    $$('[data-variant-context]', event.target).forEach(initVariantPicker);
    $$('.reveal', event.target).forEach(function (el) { el.classList.add('is-visible'); });
  });
})();
